import { statusBadgeClass, statusLabel } from "../lib/format";

export default function StatusBadge({ status }: { status: string }) {
  const cls = statusBadgeClass[status] ?? "bg-slate-100 text-slate-700";
  const label = statusLabel[status] ?? status;
  return <span className={`inline-block text-xs font-medium px-2 py-1 rounded-full ${cls}`}>{label}</span>;
}
